<template lang="pug">
  div#notices-list
    BNotification(:active.sync="error" type="is-danger" :duration="3000")
      | {{ errorMessage }}
    WtTile.notice-tile.is-flex-direction-column.mb-6(v-for="notice in notices" :key="notice.id")
      BNotification.notice-preview.mb-4(
        type="is-lightgrey"
        :closable="false"
      )
        WtDisplayRichTextHTML(:html="notice.text")
      .is-flex
        WtTile
          h1.is-family-secondary Active Dates:{{" "}}
            span.is-family-primary.pl-1 {{ moment(notice.begins).format("MM/DD/YYYY") }} - {{ moment(notice.expires).format("MM/DD/YYYY") }}
        WtTile.is-justify-content-flex-end
          WtButton.mr-4(
            :outlined="true"
            @click.native="editNotice(notice)"
          ) Edit
          WtButton(
            color="red"
            @click.native="removeNotice(notice.id)"
          ) Delete
      hr.divider
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtTitle from "../WtTitle/WtTitle";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { mapActions } from "vuex";

export default {
  name: "MemberCenterAdminActiveNoticesList",

  components: {
    WtTitle,
    WtTile,
    WtButton,
    WtDisplayRichTextHTML
  },

  mixins: [dateUtilityMixin],

  props: {
    notices: {
      type: Array,
      default: () => []
    },
    editNotice: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      error: false,
      errorMessage: null
    };
  },

  computed: {},

  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("notices", [
      "removeAdminMemberNotice",
      "removeProgramAndMemberNotice"
    ]),
    async removeNotice(noticeId) {
      this.$buefy.dialog.confirm({
        title: "Remove Notice For All Members",
        confirmText: "Remove Notice For All Members",
        type: "is-danger",
        hasIcon: true,
        message: "Are you sure you want to remove this notice for all members?",
        closeOnConfirm: false,
        onConfirm: async (_, dialog) => {
          dialog.confirmText = "Processing ...";
          dialog.$refs.confirmButton.disabled = true;
          const response = await this.removeAdminMemberNotice({
            noticeId: noticeId
          });
          if (response.error) {
            this.error = true;
            this.errorMessage = response.message;
          } else {
            this.snackBar({
              message: "Notice has been removed."
            });

            this.removeProgramAndMemberNotice(noticeId);
          }
          dialog.close();
        }
      });
    }
  }
};
</script>

<style lang="sass">
.divider
  border: 1px solid $grey
</style>
